@if (isMobile$ | async) {
<epc-split-navigation></epc-split-navigation>
} @else {
<epc-full-header></epc-full-header>
<ng-container
  *epcFeatureFlag="
    bannerEnabledFeatureKey;
    namespace: pulseNamespace;
    equality: true;
    defaultValue: false
  "
>
  <router-outlet></router-outlet>
</ng-container>
<epc-secondary-navigation-bar></epc-secondary-navigation-bar>
}
